<template>
	<div>
		<v-row if="shipment_details">
			<!--  -->
			<v-col cols="4" md="12" class="pt-0">
				<v-card class="d-flex flex-row cursor-pointer" flat >
					<v-card  flat >
						<img src="../../../assets/order.svg" alt="img"  width="25px" class="mt-3 mr-1">
					</v-card>
					<v-card  flat >
						<p>{{$lang.SHIPMENT_ID}}</p> 
						<p class="sub-title-text underline" @click="gotoShipmentDetails(shipment_details)">{{shipment_details.shipment_id}}</p>
					</v-card>
				</v-card>

			</v-col>
			<v-col md="12" cols="4" class="pt-0">
				<v-card class="d-flex flex-row " flat >
					<v-card  flat >
						<img src="../../../assets/calender.svg" alt="img"  width="25px" class="mt-3 mr-1">
					</v-card>
					<v-card  flat >
						<p>{{$lang.DATE}}</p>
						<p class="sub-title-text">{{shipment_details.shipment_created}}</p>
					</v-card>
				</v-card>

			</v-col>

			<v-col md="12" cols="4" class="pt-0">
				<div v-if="shipment_details.shipment_status">
					<span  :class="getClassSatus(shipment_details.shipment_status)">{{shipment_details.shipment_status}}</span>
				</div>
			</v-col>

			<v-col md="4" cols="4" class="pt-0">
				<v-card class="d-flex flex-row mb-6 pt-0" flat >
					<v-card   flat >
						<img src="../../../assets/drawer/shipment-active.svg"  alt="img"  width="25px" class="mt-5">
					</v-card>
					<v-card class="pa-2" flat >
						<p>{{$lang.PACKETS}}</p>
						<p class="sub-title-text">{{shipment_details.number_of_packets}}</p>
					</v-card>
				</v-card>
			</v-col>
			<v-col md="4" cols="4" class="pt-0">
				<v-card class="d-flex flex-row mb-6 pt-0" flat >
					<v-card   flat >
						<v-btn color="primary" outlined fab  x-small  class="mt-4">
							<v-icon color="primary">mdi-currency-inr</v-icon>
						</v-btn>
					</v-card>
					<v-card class="pa-2" flat >
						<p>{{$lang.AMOUNT}}</p>
						<p class="sub-title-text">{{shipment_details.shipment_amount}}</p>
					</v-card>
				</v-card>
			</v-col>
			<v-col md="4" cols="4" class="pt-2 ">
				<p>{{$lang.MODE}}</p>
				<p class="sub-title-text">{{shipment_details.payment_mode}}</p>
			</v-col>
			<v-col md="12" cols="12" class="pt-2 ">
				<!--  -->
				<div class="mb-5 pb-3">
					<p class="sub-title-text-dark">{{$lang.RETAILER_DETAILS}}</p>
					<p class="secondary-text">{{shipment_details.retailer_firm_name}}</p>
					<p class="secondary-text">{{$lang.MOBILE_PREFIX}}{{shipment_details.retailer_mobile_number}}</p>
				</div>
				<div class="mb-5 pb-3">
					<p class="sub-title-text-dark">{{$lang.CHALLAN_NUMBER}}</p>
					<p class="secondary-text">{{shipment_details.challan_number}}</p>
				</div>
			</v-col>
		</v-row>

	</div>
</template>
<script type="text/javascript">
export default{
	props:['shipment_details']
}

</script>